import { Alert } from '../../alerts/models/Alert';
import { triggerStateMapping } from '../../alerts/triggerStateMapping';

export const filterAlertsByPropertyId = (alerts: Alert[], propertyId: string): Alert | null => {
    const propertyAlerts = alerts.filter((alert) => triggerStateMapping.get(alert.id_trigger) === propertyId);
    return propertyAlerts.length ? propertyAlerts[0] : null;
};

export function filterAlertsDevice(deviceId: string, alerts: Alert[]): Alert[] {
    return alerts.filter((alert) => alert.id_device === deviceId);
}
